import { type ExtendShiftConfig, ExtendShiftState } from "@clipboard-health/flag-backend-main";

interface ExtendShiftConfigResult {
  extendShiftConfig: ExtendShiftConfig | undefined;
  allowedExtendedTimeInMinutes: number | null;
}

export function getExtendShiftConfig(
  extendShiftConfig: ExtendShiftConfig | undefined
): ExtendShiftConfigResult {
  if (!extendShiftConfig || extendShiftConfig.state === ExtendShiftState.DISABLED) {
    return { extendShiftConfig, allowedExtendedTimeInMinutes: null };
  }

  if (extendShiftConfig.state === ExtendShiftState.SHIFT_EXTENSION_DISABLED) {
    return { extendShiftConfig, allowedExtendedTimeInMinutes: 0 };
  }

  return {
    extendShiftConfig,
    allowedExtendedTimeInMinutes: extendShiftConfig.maxShiftLengthInMinutes,
  };
}
